// extracted by mini-css-extract-plugin
module.exports = {"authButton":"AuthButton_authButton__3D9N5"};